import * as types from '../../action-types';
import { getAdvanceDetails as initialState } from "../../initialState";

const getAdvanceDetails = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ADVANCE_DETAILS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ADVANCE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ADVANCE_DETAILS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ADVANCE_DETAILS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAdvanceDetails;
